module.exports = __webpack_public_path__ + "assets/tools-10f6a57fec8e7e3e989ea71b22d24c69.svg";